module.exports = __webpack_public_path__ + "static/viola_en-7f7217889a101cdd5109aa4a5404ed53.pdf";